// extracted by mini-css-extract-plugin
export default {"board":"board_board__FB2ZM","hover":"board_hover__9+Nef","create":"board_create__1TgEU","missing":"board_missing__lJpmR"};